import axios from "axios";
import {
  checkoutProductLists,
  FreeshipProductsScrollList,
  CrossSaleProductsScrollList,
} from "./product_list";

import { rootUrl, paymentCheckTimeout } from "./config";

var paymentCheckTime = null;

function freezeUI() {
  $("div.checkout-basket").LoadingOverlay("show", {
    image: "",
    text: "",
    background: "rgba(255,255,255,0.3)",
    zIndex: 1003,
    fade: false,
  });
}

function unFreezeUI() {
  $("div.checkout-basket").LoadingOverlay("hide", true);
}

function bindCheckoutPaymentEvents() {
  $("form[name='address_info']").validate({
    highlight: function(element, errorClass, validClass) {
      $(element).addClass(errorClass).removeClass(validClass);
      $(element.form).find("label[for=" + element.id + "]")
        .addClass(errorClass);
    },
    unhighlight: function(element, errorClass, validClass) {
      $(element).removeClass(errorClass).addClass(validClass);
      let current_label = $(element.form).find("label[for=" + element.id + "]");
      current_label.removeClass(errorClass);
      if(current_label.length ){
        current_label.text($(element).data("labelvaule"));
        current_label.css("display", "block");
      }
    },
    rules: {
      full_name: { required: true },
      address: { required: true },
      city: { required: true },
      district: { required: true },
      email: { required: false },
      ward: { required: true },
      mobile_phone: { required: true },
    },
    messages: {
      full_name: $("input[name='full_name']").data("errmsg"),
      address: $("input[name='address']").data("errmsg"),
      city: $("select[name='city']").data("errmsg"),
      district: $("select[name='district']").data("errmsg"),
      email: $("select[name='email']").data("errmsg"),
      ward: $("select[name='ward']").data("errmsg"),
      mobile_phone: $("input[name='mobile_phone']").data("errmsg"),
    },
  });

  $("button[name='btn_place_order']").on("click", function (evt) {
    evt.stopImmediatePropagation();
    placeOrder(this);
  });
}

function bindCheckoutBasketEvents() {
  $("button[name='co_remove_item']").on("click", function (e) {
    removeItem($(this).closest("div.co-basket-row").data("pid"), this);
  });
  $("button[name='co_decrease_qty'],button[name='co_increase_qty']").on(
    "click",
    function (e) {
      changeQty(
        $(this).closest("div.co-basket-row").data("pid"),
        $(this).val(),
        this
      );
    }
  );
  $("input[name='co_qty']").on("change", function (e) {
    changeQty($(this).closest("div.co-basket-row").data("pid"), $(this).val(), this);
  });
}

function typeahead_autocomplete_for_discountbox(ele){
  $.typeahead({
    input: '.vouchers-discounts-input-box',
    dynamic: true,
    delay: 500,
    maxItem: 20,
    searchOnFocus: true,
    cache: false,
    minLength: 0,
    group: {
      key: "agency_name",
      template: function(item){
        return `<span class="avatar"><img src="${item.agency_image}"></span>  ${item.agency_name}`;
      }
    },
    //dropdownFilter: "service points",
    template: function (query, item) {
      var color = "#ff1493";
      return '<span class="row">' +
             '<span class="name">{{code}}</span>' +
             '<span class="addr">{{header}}</span>' +
             '</span>';
    },
    emptyTemplate: "Không tìm thấy mã giảm giá <a href='/voucher'>Săn ngay</a>",
    templateValue: "{{code}}",
    multiselect: {
      limit: 5,
      limitTemplate: 'Bạn không thể chọn nhiều hơn 5 mã giảm giá.',
      matchOn: ["code"],
      cancelOnBackspace: true,
      callback: {
        onClick: function (node, item, event) {
          console.log(item.code + ' Clicked!');
        },
        onCancel: function (node, item, event) {
          console.log(item.code + ' Removed!');
        }
      }
    },    
    source: {
      services: {
          display: ["code","header","agency_name","detail"],
          ajax: function(query) {
            return {
              type: "GET",
              url: `${rootUrl}/customer/storedVouchers`,
              data: {
                searchTerm: '{{query}}'
              },
              //path: 'services',
              callback: {
                  done: function (data, textStatus, jqXHR) {
                    //console.log(data);
                    // Perform operations on received data...
                    // IMPORTANT: data has to be returned if this callback is used
                      return data;
                  },
                  fail: function (jqXHR, textStatus, errorThrown) {},
                  always :function (data, textStatus, jqXHR) {},
                  then: function (jqXHR, textStatus) {}
              }            
            }
          }
      }    
    },
    callback: {
        onInit: function (node) {
          //console.log('Typeahead Initiated on ',$(node).selector);
        },
        onReady: function (node) {
          //console.log('Typeahead is ready on ',node);
          //$(node).closest(".typeahead__container").addClass("cancel");
          //typeahead__container cancel result
        },
        onShowLayout: function (node, query) {
          console.log('Typeahead shows layout on ', node, " with query "+query);
        },
        onHideLayout: function (node, query) {
          //console.log('Typeahead hide layout on ' , node, " with query "+query);
        },
        onSearch: function (node, query) {
          //console.log('Typeahead searchs on ' , node, " with query "+query);
        },
        onResult (node, query, result, resultCount, resultCountPerGroup) {
          console.log('Typeahead results on ' , node, " with query "+query);
          //console.log("Result: ", result, "Count: ", resultCount, "Countpergroup: ",resultCountPerGroup);
        },
        onClick: function (node, a, item, event) {
          //console.log("Click: ",node, a,item,event);
        },
        onClickBefore: function (node, a, item, event) {
          //console.log("Click Before: ",node, a,item,event);
        },
        onClickAfter: function (node, a, item, event) {
        },
        onCancel: function (node, item, event) {
          //console.log("Cancel Node: ",node);
          //console.log("Cancel Item: ",item);
          //console.log("Cancel Event: ",event);
        },
        onSubmit: function (node, form, items, event) {
          event.preventDefault();
          let codes = _.map(items, it => { return it.code;});
          //alert(codes.join(","));
          let url = `${rootUrl}/checkout/applydiscount`;
          freezeUI();
          axios({
            url: url,
            method: "POST",
            data: { discount_codes: codes.join(",") },
          }).then(function (res) {
            unFreezeUI();
            if (res.data && res.data.html) bindCheckoutToUI(res.data);
            else if (res.data && res.data.error) {
              $(ele).closest("div.co-input-group").find("div.error").html(res.data.error);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        }
      },
    debug: true
  });  
}

function bindCheckoutBasketFooter() {
  // $("input[name='discount_box']").autocomplete();
  typeahead_autocomplete_for_discountbox($("input[name='discount_box']"));

  $("button[name='discount_activate']").on("click", function (e) {
    //applyDiscount(this);
  });
  $("span.giftcard-item>i").on("click", function (e) {
    removeGiftcard(this);
  });
  $("button[name='giftcard_activate']").on("click", function (e) {
    applyGiftcard(this);
  });
  $("div.disc-applied>span>i").on("click", function (e) {
    removeDiscount(this);
  });
  $("textarea[name='co_msg_text']").on("change", function (e) {
    msgChanged(this);
  });
  $("input[name='discount_box']").on("click", function (e) {
    $(this).closest("div.co-discount-giftcards").find("div.error").html("");
  });
}

function bindCheckoutShipmentEvents() {
  $(".btn-viettelpost").on("click",function(e){
    $(".btn-viettelpost").removeClass("btn-focus");
    if($('#shipmentViettelPOST:checked').length){
      $(".btn-viettelpost").removeAttr('data-selected');
      $(this).attr('data-selected', true);
    }else{
      $(this).attr('data-selected', true);
      $("#shipmentViettelPOST").attr('checked', 'checked');
    }
    $(this).addClass( "btn-focus" );
    changeShipment($("#shipmentViettelPOST").val(), $("#shipmentViettelPOST"), $(this).attr('data-service'));
  });

  $("input[name='shipment_type']").on("change", function (e) {
    let viettelpost_ele = $('#shipmentViettelPOST:checked');
    let first_service_vt = $(".btn-viettelpost").first();
    let service ;
    if(viettelpost_ele.length){
      $(".btn-viettelpost").removeClass("btn-focus");
      first_service_vt.attr('data-selected', true);
      first_service_vt.addClass( "btn-focus");
      service =  first_service_vt.attr('data-service');
      $("#ViettelPOST-group-btn").css("display", "block");
    }
    changeShipment($(this).val(), this, service);
  });
}

function bindCheckoutShipmentAddrEvents() {
  $("select[name='ward']").on("change", function (e) {
    let ward = $(this).val();
    let dist = $("select[name='district']").val();
    let city = $("select[name='city']").val();
    changeShipmentAddr({ ward, dist, city }, this);
  });
  $("input[name='FilledAddr']").on("load", function (e) {
    console.log("call changeShipmentAddr()")
    let ward = $("select[name='ward']").val();
    let dist = $("select[name='district']").val();
    let city = $("select[name='city']").val();
    changeShipmentAddr({ ward, dist, city }, this);
  });
  $("input[name='onload_addr']").on("load", function (e) {
    changeShipmentAddr({ ward, dist, city }, this);
  });
}

function onCheckoutPaymentEvents() {
  $("input[name='payment_type']").on("change", function (e) {
    changePaymentType($(this).val(), this);
  });
}

function bindCheckoutAddressEvents() {
  $("#checkout_page select[name='addrSelected']").on("change", function (e) {
    selectedAddr($(this).val(), this);
  });

  $("form[name='address_info'] select[name='city']").on("change", function (e) {
    fetchDistricts($(this).val(), this);
  });

  $("form[name='address_info'] select[name='district']").on("change", function (e) {
    fetchWards($(this).val(), this);
  });
  $("#checkout_page select[name='addrSelected']").trigger("change");
}

function bindCheckoutServicePointEvent() {
  $("select[name='service_point']").on("change", function (e) {
    changeServicePoint($(this).val(), this);
  });
  $("button[name='serv_point_search']").on("click", function (e) {
    searchServicePoint($("input[name='city_postal_code']").val(), this);
  });
}

function bindCheckoutEvents() {
  bindCheckoutBasketEvents();
  bindCheckoutBasketFooter();
  bindCheckoutShipmentEvents();
  bindCheckoutShipmentAddrEvents();
  onCheckoutPaymentEvents();
  bindCheckoutServicePointEvent();
  bindPaymentGatewayEvents();
  bindCheckoutPaymentEvents();
  checkoutProductLists();
  displayOutStockMsg();
  bindCheckoutAddressEvents();
}

function scrollToTopAndShowMsgBox() {
  //document.getElementById("checkout_page").scrollIntoView(true);
  $("html, body").animate(
    { scrollTop: $("#checkout_page").position().top },
    600,
    function () {
      $("#wex_message_box").removeClass("hide");
    }
  );
}

function displaySwishErrorMsg(msg) {
  $("#wex_message_box span.msg-content").html(msg);
  $("#wex_message_box").removeClass("hide");
}

function displayOutStockMsg() {
  let ready4checkout = $("#checkout_page div.co-basket-rows").data(
    "read-for-checkout"
  );
  let isShowMsg = $("#checkout_page input[name='showStockMsg']").val() == "show";
  if (!ready4checkout && isShowMsg) scrollToTopAndShowMsgBox();
}

function bindPaymentGatewayEvents() {
  $("button.gatewaylinks").on("click", function (e) {
    changePaymentType($(this).data("payment-name"), this);
  });
}

function servicePointChanged(data) {
  if (data && data.status && data.services && data.services.length) {
    $("select[name='service_point']").children("option:not(:first)").remove();
    $.each(data.services, function (key, value) {
      $("select[name='service_point']").append(
        $("<option></option>")
          .attr("value", value.servicePointId)
          .text(
            value.name +
              ", " +
              value.deliveryAddress.streetName +
              " " +
              value.deliveryAddress.streetNumber +
              ", " +
              value.deliveryAddress.city +
              " (" +
              value.deliveryAddress.postalCode +
              ")"
          )
      );
    });
  }
}

function bindCheckoutToUI(data) {
  var scrollPos = $("html").scrollTop();
  if (data && data.html) {
    let $new = $(data.html);
    if ($new.find("div.co-basket-rows").length) {
      $("div.checkout-basket")
        .find("div.co-basket-rows")
        .replaceWith($new.find("div.co-basket-rows"));
      bindCheckoutBasketEvents();
    }
    if ($new.find("div.co-basket-total-footer").length) {
      $("div.checkout-basket")
        .find("div.co-basket-total-footer")
        .replaceWith($new.find("div.co-basket-total-footer"));
      bindCheckoutBasketFooter();
    }
    if ($new.find("div.co-shipment-rows").length) {
      $("div.checkout-basket")
        .find("div.co-shipment-rows")
        .replaceWith($new.find("div.co-shipment-rows"));
      bindCheckoutShipmentEvents();
    }
    if ($new.find("div.co-payment-rows").length) {
      $("div.checkout-basket")
        .find("div.co-payment-rows")
        .replaceWith($new.find("div.co-payment-rows"));
      onCheckoutPaymentEvents();
    }
    $("div.checkout-basket").find("#products_crosssale").remove();
    if ($new.find("#products_crosssale").length) {
      $new
        .find("#products_crosssale")
        .insertAfter($("div.checkout-basket div.co-basket-total-footer"));
      CrossSaleProductsScrollList();
    }
    $("div.checkout-basket").find("#products_freeship").remove();
    if ($new.find("#products_freeship").length) {
      $new
        .find("#products_freeship")
        .insertAfter($("div.checkout-basket div.co-basket-total-footer"));
      FreeshipProductsScrollList();
    }
  }
  $("html").scrollTop(scrollPos);
}

function msgChanged(ele) {
  let url = `${rootUrl}/checkout/msgchange`;
  axios({ url: url, method: "POST", data: { msg: $(ele).val() } })
    .then(function (res) {
      console.log(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function removeDiscount(ele) {
  let url = `${rootUrl}/checkout/removediscount`;
  freezeUI();
  let discount_code = $(ele).closest("span.discount-item").data("disc-code");
  axios({ url: url, method: "POST", data: { discount_code: discount_code } })
    .then(function (res) {
      unFreezeUI();
      if (res.data && res.data.html) bindCheckoutToUI(res.data);
      else if (res.data && res.data.error) {
        $(ele)
          .closest("div.co-discount-giftcards")
          .find("div.error")
          .html(res.data.error);
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function removeGiftcard(ele) {
  let url = `${rootUrl}/checkout/removegiftcard`;
  freezeUI();
  let giftcard = $(ele).closest("span.giftcard-item").data("gc-code");
  axios({ url: url, method: "POST", data: { giftcards: giftcard } })
    .then(function (res) {
      unFreezeUI();
      if (res.data && res.data.html) bindCheckoutToUI(res.data);
      else if (res.data && res.data.error) {
        $(ele)
          .closest("div.co-discount-giftcards")
          .find("div.error")
          .html(res.data.error);
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function applyGiftcard(ele) {
  let url = `${rootUrl}/checkout/applygiftcard`;
  freezeUI();
  axios({
    url: url,
    method: "POST",
    data: {
      giftcards: $("input[name='giftcard_box']").val(),
      basket_total: $("input[name='basket_total']").val(),
    },
  })
    .then(function (res) {
      unFreezeUI();
      if (res.data && res.data.html) bindCheckoutToUI(res.data);
      else if (res.data && res.data.applyGC) {
        let errorMsg = "";
        for (let k in res.data.applyGC)
          errorMsg += errorMsg
            ? " - " + res.data.applyGC[k].error
            : res.data.applyGC[k].error;
        $(ele).closest("div.co-input-group").find("div.error").html(errorMsg);
      }
    })
    .catch(function (err) {
      unFreezeUI();
      console.log(err);
    });
}

function applyDiscount(ele) {
  let url = `${rootUrl}/checkout/applydiscount`;
  freezeUI();
  axios({
    url: url,
    method: "POST",
    data: { discount_codes: $("input[name='discount_box']").val() },
  })
    .then(function (res) {
      unFreezeUI();
      if (res.data && res.data.html) bindCheckoutToUI(res.data);
      else if (res.data && res.data.error) {
        $(ele).closest("div.co-input-group").find("div.error").html(res.data.error);
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function add2basketfromco(ele, pId, from) {
  let url = `${rootUrl}/checkout/add2basket`;
  freezeUI();
  axios({ url: url, method: "POST", data: { product_id: pId, qty: 1, from: from } })
    .then(function (res) {
      unFreezeUI();
      bindCheckoutToUI(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function removeItem(pId, ele) {
  let url = `${rootUrl}/checkout/removeit`;
  freezeUI();
  axios({ url: url, method: "POST", data: { product_id: pId } })
    .then(function (res) {
      unFreezeUI();
      bindCheckoutToUI(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function changeShipment(sm_type, ele, sm_service) {
  console.log("Enter changeShipment()")
  let url = `${rootUrl}/checkout/changesm`;
  freezeUI();
  axios({ url: url, method: "POST", data: { sm_type: sm_type, sm_service: sm_service} })
    .then(function (res) {
      unFreezeUI();
      bindCheckoutToUI(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function changeShipmentAddr(addr, ele) {
  let url = `${rootUrl}/checkout/changesmaddr`;
  freezeUI();
  axios({ url: url, method: "POST", data: { addr: addr } })
    .then(function (res) {
      unFreezeUI();
      bindCheckoutToUI(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function searchServicePoint(city_postalCode, ele) {
  let url = `${rootUrl}/checkout/searchservpoint`;
  axios
    .get(url, { params: { city_postalCode: city_postalCode } })
    .then(function (res) {
      servicePointChanged(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function changeServicePoint(servId, ele) {
  let url = `${rootUrl}/checkout/changeservpoint`;
  axios({ url: url, method: "POST", data: { serv_id: servId } })
    .then(function (res) {
      servicePointChanged(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function changePaymentType(payment_name, ele) {
  let url = `${rootUrl}/checkout/changepm`;
  axios({ url: url, method: "POST", data: { payment_name: payment_name } })
    .then(function (res) {
      if (res && res.data && res.data.html) {
        $("#currentGateway_info").empty().html(res.data.html);
        $("button.gatewaylinks").removeClass("active");
        $(ele).addClass("active");
        bindCheckoutPaymentEvents();
      }
    })
    .catch(function (err) {
      console.log(err);
    });
}

function changeQty(pId, qty, ele) {
  let url = `${rootUrl}/checkout/changeqty`;
  freezeUI();
  axios({ url: url, method: "POST", data: { product_id: pId, qty: qty } })
    .then(function (res) {
      unFreezeUI();
      bindCheckoutToUI(res.data);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function selectedAddr(addrId, ele) {
  let url = `${rootUrl}/checkout/addrchanged?addrId=${addrId}`;
  freezeUI();
  axios({ url: url, method: "POST" })
    .then(function (res) {
      unFreezeUI();
      console.log(res.data);
      if (res.data && res.data.status && res.data.selAddr) {
        const selAddr = res.data.selAddr;

        $("form[name='address_info'] input[name='full_name']").val(
          selAddr.full_name
        );
        $("form[name='address_info'] input[name='mobile_phone']").val(
          selAddr.phone_number
        );
        $("form[name='address_info'] input[name='email']").val(selAddr.email);
        $("form[name='address_info'] input[name='address']").val(selAddr.address);
        $("form[name='address_info'] select[name='city']").val(selAddr.city);
        if (selAddr.dist) {
          fetchDistricts(
            selAddr.city,
            $("form[name='address_info'] select[name='district']"),
            selAddr.dist
          );
        }
        if (selAddr.ward) {
          fetchWards(
            selAddr.dist,
            $("form[name='address_info'] select[name='ward']"),
            selAddr.ward
          );
        }
        console.log('call changeShipmentAddr')
        const addr = {
          city: res.data.selAddr.city,
          dist: res.data.selAddr.dist,
          ward: res.data.selAddr.ward,
        }
        changeShipmentAddr(addr)
      }
      //bindOptsToElement(res.data, $("form[name='address_info'] select[name='district']"));



    })
    .catch(function (err) {
      console.log(err);
    });
}

function fetchDistricts(city_code, ele, selVal) {
  let url = `${rootUrl}/address/districts?city_code=${city_code}`;
  freezeUI();
  axios({ url: url, method: "GET" })
    .then(function (res) {
      unFreezeUI();
      bindOptsToElement(
        res.data,
        $("form[name='address_info'] select[name='district']"),
        selVal
      );
    })
    .catch(function (err) {
      console.log(err);
    });
}

function fetchWards(dt_code, ele, selVal) {
  let url = `${rootUrl}/address/wards?dt_code=${dt_code}`;
  freezeUI();
  axios({ url: url, method: "GET" })
    .then(function (res) {
      unFreezeUI();
      bindOptsToElement(
        res.data,
        $("form[name='address_info'] select[name='ward']"),
        selVal
      );
    })
    .catch(function (err) {
      console.log(err);
    });
}

function bindOptsToElement(items, ele, selVal) {
  if (items && items.length) {
    $(ele).children("option:not(:first)").remove();
    $.each(items, function (key, value) {
      $(ele).append(
        $("<option></option>").attr("value", value.code).text(value.full_name)
      );
    });
    if (selVal) $(ele).val(selVal);
  }
}

function checkPaymentStatus() {
  let url = `${rootUrl}/checkout/checkpaymentstatus`;
  let data = {
    token: $("input[name='payment_token']").val(),
  };
  showProgress($("form.payment-info-form").attr("name"));
  clearTimeout(paymentCheckTime);
  axios({ url: url, method: "POST", data: data })
    .then(function (res) {
      const data = res.data;
      if (data && data.status == "process") {
        paymentCheckTime = setTimeout(checkPaymentStatus, paymentCheckTimeout);
      } else if (data && data.status == "complete") {
        hideProgress();
        location.href = `${rootUrl}/checkout/confirmation?pid=${data.id}`;
      } else {
        hideProgress();
        console.log(data);
      }
    })
    .catch(function (err) {
      hideProgress();
      console.log(err);
    });
}

function showProgress(name) {
  $("button[name='btn_place_order']").addClass("prevent-click");
  if (name == "swish") {
    $("div.checkout-progress .progress-text").css({ display: "none" });
    $("div.checkout-progress .progress-text-swish").css({ display: "flex" });
  } else {
    $("div.checkout-progress .progress-text").css({ display: "flex" });
    $("div.checkout-progress .progress-text-swish").css({ display: "none" });
  }
  $("div.checkout-progress").show();
}

function hideProgress() {
  $("button[name='btn_place_order']").removeClass("prevent-click");
  $("div.checkout-progress").hide();
}

function openSwishApp(data) {
  let swishcb_url = `${rootUrl}/checkout/swishsamedevice?uuid=${data.uuid}&order_id=${data.order_id}`;
  let app_url = `swish://paymentrequest?token=${data.swishToken}&callbackurl=${swishcb_url}`;
  paymentCheckTime = setTimeout(checkPaymentStatus, paymentCheckTimeout);
  window.location.replace(app_url);
}

function placeOrder(ele) {
  if ($("form[name='address_info']").valid()) {
    let data = $("form.payment-info-form").serialize();
    console.log(data);
    if($('input[name="shipment_type"]:checked').val()=== "ViettelPOST"){
      $(".btn-viettelpost").each(function(index){
        console.log("-------------$(this).attr('data-selected')="+$(this).attr('data-selected'))
        if ($(this).attr('data-selected')){
          data=data+"&ViettelPOST_service="+$(this).attr('data-service');
        }
      });
    }
    let url = `${rootUrl}/checkout/placeorder`;
    console.log("placeOrder() data = ", data);

    showProgress("general");
    axios({ url: url, method: "POST", data: data })
      .then(function (res) {
        hideProgress();
        let data = res.data;
        if (data.status && data.order_id && data.needPaymentProcess) {
          location.href = `${rootUrl}/${data.paymentURL}`;
          return;
        }
        if (data.status && data.order_id) {
          location.href = `${rootUrl}/checkout/confirmation?pid=${data.order_id}`;
          return;
        }
      })
      .catch(function (err) {
        hideProgress();
        console.log(err);
      });

    //scrollToTopAndShowMsgBox();
  }
  else{
    $('html, body').animate({
      scrollTop: ($('.error').offset().top - 300)
    }, 2000);
  }
}
export { bindCheckoutEvents, add2basketfromco };
